import { useForm } from '@tanstack/react-form'

import { publicarNovedadSchema, type PublicarNovedadFormValues } from './publicarNovedadSchema'

export interface UsePublicarNovedadFormOptions {
  onSubmit?: (values: PublicarNovedadFormValues) => void | Promise<void>
}

const DEFAULT_VALUES = { titulo: '', mensaje: '' } satisfies PublicarNovedadFormValues

export function usePublicarNovedadForm(options: UsePublicarNovedadFormOptions = {}) {
  const { onSubmit } = options

  const form = useForm({
    defaultValues: { ...DEFAULT_VALUES } as PublicarNovedadFormValues,
    validators: {
      onSubmit: publicarNovedadSchema,
    },
    onSubmit: async ({ value }) => {
      if (onSubmit) {
        await onSubmit(value)
      }
    },
  })

  return { form }
}

export type UsePublicarNovedadFormReturn = ReturnType<typeof usePublicarNovedadForm>
export type PublicarNovedadForm = UsePublicarNovedadFormReturn['form']
